import type {Components, CSSObject, Theme} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';

const chipFilledStyle = (
    backgroundColor: string,
    hoverBackgroundColor: string,
    color: string,
): CSSObject => ({
    backgroundColor,
    color,
    '&:hover:not(.Mui-disabled)': {
        backgroundColor: hoverBackgroundColor,
    },
    '& .MuiChip-icon': {
        color,
    },
    '& .MuiChip-deleteIcon': {
        color,
    },
});

const chipOutlinedStyle = (
    hoverBackgroundColor: string,
    color: string,
): CSSObject => ({
    color,
    '&:hover:not(.Mui-disabled)': {
        backgroundColor: hoverBackgroundColor,
    },
    '& .MuiChip-icon': {
        color,
    },
    '& .MuiChip-deleteIcon': {
        color,
    },
});

export const chipOverrides: Components<Theme>['MuiChip'] = {
    styleOverrides: {
        root: {
            maxHeight: '24px',
            '&.MuiChip-filled:not(.MithraTag-root)': {
                '&.MuiChip-colorDefault': chipFilledStyle(COLORS.grey[100], COLORS.grey[300], COLORS.black[500]),
                '&.MuiChip-colorPrimary': chipFilledStyle(COLORS.primary[300], COLORS.primary[400], COLORS.primary.main),
                '&.MuiChip-colorSecondary': chipFilledStyle(COLORS.secondary[100], COLORS.secondary[300], COLORS.secondary.main),
                '&.MuiChip-colorSuccess': chipFilledStyle(COLORS.success[100], COLORS.success[300], COLORS.success.main),
                '&.MuiChip-colorError': chipFilledStyle(COLORS.error[100], COLORS.error[300], COLORS.error.main),
                '&.MuiChip-colorWarning': chipFilledStyle(COLORS.warning[100], COLORS.warning[300], COLORS.warning.main),
                '&.MuiChip-colorInfo': chipFilledStyle(COLORS.mithraBlue[100], COLORS.mithraBlue[300], COLORS.info.main),
            },
            '&.MuiChip-outlined:not(.MithraTag-root)': {
                '&.MuiChip-colorDefault': chipOutlinedStyle(COLORS.grey[100], COLORS.black[500]),
                '&.MuiChip-colorPrimary': chipOutlinedStyle(COLORS.primary[100], COLORS.primary.main),
                '&.MuiChip-colorSecondary': chipOutlinedStyle(COLORS.secondary[100], COLORS.secondary.main),
                '&.MuiChip-colorSuccess': chipOutlinedStyle(COLORS.success[100], COLORS.success.main),
                '&.MuiChip-colorError': chipOutlinedStyle(COLORS.error[100], COLORS.error.main),
                '&.MuiChip-colorWarning': chipOutlinedStyle(COLORS.warning[100], COLORS.warning.main),
                '&.MuiChip-colorInfo': chipOutlinedStyle(COLORS.mithraBlue[100], COLORS.info.main),
            },
        },
    },
};
